import { Link } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { ArrowRight } from "lucide-react";

const NotFound = () => {
  useDocumentTitle("Page introuvable | cartonmove", "La page demandée n'existe pas ou a été déplacée.");

  return (
    <div className="container-cdm py-20 sm:py-28 text-center" data-testid="not-found-page">
      <div className="overline justify-center">Erreur 404</div>
      <h1 className="mt-4 text-[28px] sm:text-[33px] md:text-[48px] font-extrabold text-[#0f1d2b]">Page introuvable</h1>
      <p className="mt-5 max-w-xl mx-auto text-[15px] text-[#3a4a5a] leading-[1.8]">
        La page que vous cherchez n'existe pas ou a été déplacée.
        Découvrez nos cartons de déménagement à Paris et en Île-de-France.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/" className="btn-outline-blue" data-testid="404-home">
          Retour à l'accueil
        </Link>
        <Link to="/cartons-demenagement" className="btn-primary" data-testid="404-shop">
          Voir nos cartons <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
